import { render, staticRenderFns } from "./ResidentEdit.vue?vue&type=template&id=7d96887d&scoped=true"
import script from "./ResidentEdit.vue?vue&type=script&lang=js"
export * from "./ResidentEdit.vue?vue&type=script&lang=js"
import style0 from "./ResidentEdit.vue?vue&type=style&index=0&id=7d96887d&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96887d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d96887d')) {
      api.createRecord('7d96887d', component.options)
    } else {
      api.reload('7d96887d', component.options)
    }
    module.hot.accept("./ResidentEdit.vue?vue&type=template&id=7d96887d&scoped=true", function () {
      api.rerender('7d96887d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolManage/resident/ResidentEdit.vue"
export default component.exports